import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { HomePage } from '@/components/HomePage';
import { UnifiedEditorPage } from '@/components/UnifiedEditorPage';
import { HVACEditorPage } from '@/components/HVACEditorPage';
import { PlantLoopEditorPage } from '@/components/PlantLoopEditorPage';
import { ScheduleEditorPage } from '@/schedule';
import { TemplatesPage } from '@/components/TemplatesPage';
import { WeatherPage } from '@/components/WeatherPage';
import { SimulationPage } from '@/components/SimulationPage';
import { GeometryViewerPage } from '@/components/GeometryViewerPage';
import { ResultsDashboard } from '@/results/components/ResultsDashboard';
import { ExamplesPage } from '@/components/ExamplesPage';
import { DocsPage } from '@/docs';
import { FileManagerProvider } from '@/storage';

function App() {
  return (
    <FileManagerProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="editor" element={<UnifiedEditorPage />} />
          {/* Redirect /objects to /editor for backwards compatibility */}
          <Route path="objects" element={<Navigate to="/editor" replace />} />
          <Route path="hvac" element={<HVACEditorPage />} />
          <Route path="plant" element={<PlantLoopEditorPage />} />
          <Route path="schedules" element={<ScheduleEditorPage />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="examples" element={<ExamplesPage />} />
          <Route path="geometry" element={<GeometryViewerPage />} />
          <Route path="weather" element={<WeatherPage />} />
          <Route path="docs" element={<DocsPage />} />
          <Route path="simulate" element={<SimulationPage />} />
          <Route path="results" element={<ResultsDashboard />} />
        </Route>
      </Routes>
    </FileManagerProvider>
  );
}

export default App;
